import React from 'react'
import { useTranslation } from '@contexts/translation'
import { TablePagination, TableRow } from '@mui/material'

interface CommonPaginationProps {
  setQueries?: (prev: Record<string, any>) => void
  dispatchQueries?: (payload: Record<string, any>) => void
  count?: number
  page: number
  setPage?: (page: number) => void
  rowsPerPage: number
  setRowsPerPage?: (rowsPerPage: number) => void
}

const CommonPagination: React.FC<CommonPaginationProps> = ({
  setQueries = () => null,
  dispatchQueries = () => null,
  count = 0,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage
}) => {
  const { dictionary } = useTranslation()

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (setPage) setPage(newPage)
    if (setQueries) setQueries(prev => ({ ...prev, page: newPage + 1 }))
    if (dispatchQueries) dispatchQueries({ page: newPage + 1 })
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (setRowsPerPage) setRowsPerPage(+event.target.value)
    if (setQueries) {
      setQueries(prev => ({
        ...prev,
        // page_size: event.target.value == '-1' ? 99999 : event.target.value,
        page_size: event.target.value,
        page: 1
      }))
    }
    if (dispatchQueries)
      dispatchQueries({ page_size: event.target.value, page: 1 })
    if (setPage) setPage(0)
  }

  return (
    <TableRow hover={false}>
      <TablePagination
        labelRowsPerPage={dictionary.rows_per_page as string}
        rowsPerPageOptions={[5, 10, 25, 50, 100, { label: 'All', value: 9999 }]}
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        SelectProps={{
          inputProps: {
            'aria-label': 'rows per page'
          },
          native: true
        }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableRow>
  )
}

export default CommonPagination
